export const SupportForm = {
	list: function() {

    var options = {
      bDeferRender: true,
      data: JSON.parse(jQuery("#list-data").html()),
      info: false,
      lengthChange: false,
      language: {
        searchPlaceholder: I18n.t('search')
      },
      pageLength: 20,
      autoWidth: false,
      initComplete: function () {
        DataTablesHelper.setAutoComplete(jQuery('#support-form-table'));
      },
      columnDefs: [
        {
          targets: [2],
          searchable: false,
          sortable: false,
        },
      ],
      drawCallback: () => {
        this.priv.bindEvent();
      },
      footerCallback: function () {
        DataTablesHelper.togglePagination(this);
      }
    };

    var formTable = jQuery('#support-form-table');
    formTable.DataTable(options);
	},
  
  priv: {
    bindEvent: function(){
      jQuery('.form-clone-link, .form-delete-link').off('click').on('click', function(e){
        e.stopPropagation();
        var c = true;
        if (jQuery(this).data('confirm')){
          c = confirm(jQuery(this).data('confirm'));
        } 
        if (c) {
          jQuery.ajax({
            url: jQuery(this).attr('href'),
            method: 'POST',
            headers: {"X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr('content')},
          }).done(function(d){
            $('.dt-container').html(SmartME.loadingIndicator());
            Turbo.visit(location.href, {action: 'replace'});
          });
        }
        e.preventDefault();
      });
    }
  }
};